import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { EditDetailsDialogComponent } from '../../names-to-update/edit-details-dialog/edit-details-dialog.component';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule, FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';
import { DpTableComponent } from '../../common-component/dp-table/dp-table.component';
import { Validation } from '../../services/common/app.constant';
import { MatSelectModule } from '@angular/material/select';
import { MatAutocomplete, MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatIconModule } from '@angular/material/icon';
import { PincodeTransmissionService } from '../../services/raintree/Transmission/pincode.service';
import { ToastrService } from 'ngx-toastr';
import { LoaderComponent } from '../../common-component/loader/loader.component';
import { PincodeInterface } from '../../services/raintree/interfaces/pincode.interface';
import { PrintAndMonitorService } from '../../services/raintree/Transmission/print-and-monitor.service';
import { DpLoaderComponent } from '../../common-component/dp-loader/dp-loader.component';
import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';
import { Subscription } from 'rxjs';
import { DeafulterListService } from '../../services/raintree/Transmission/deafulter-list.service';
import { ExpiredDialogComponent } from '../../reach-defaulter/expired-dialog/expired-dialog.component';
import { FamilyCodeResponse, FamilyCodeResponseObj } from '../../services/raintree/interfaces/family-code.interface';
import { state } from '@angular/animations';
import { type } from 'os';
import { FamilyCodeTransmissionService } from '../../services/raintree/Transmission/familyCode-transmission.service';

@Component({
  selector: 'app-edit-contact-address',
  standalone: true,
  imports: [CommonModule,
    ReactiveFormsModule,
    DpTableComponent,
    FormsModule, LoaderComponent, DpLoaderComponent,
    MatDialogModule, MatSelectModule, MatAutocompleteModule, MatIconModule],
  templateUrl: './edit-contact-address.component.html',
  styleUrls: ['./edit-contact-address.component.scss', '../../../styles/_dropdown.scss']
})
export class EditContactAddressComponent implements OnInit {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<EditContactAddressComponent>,
    public pincodeTransmissionService: PincodeTransmissionService,
    private dialog: MatDialog,
    private printAndMonitorService: PrintAndMonitorService,
    private defaulterService: DeafulterListService,
    private toaster: ToastrService,
    private formBuilder: FormBuilder,
    private familyCodeTransmissionService: FamilyCodeTransmissionService
  ) { }
  @ViewChild('autofc') autofc!: MatAutocomplete;

  addDetailsForm = new FormGroup({
    contactNo: new FormControl('', [Validators.pattern(Validation.regex.phone)]),
    address: new FormControl('', [Validators.pattern('^[^*]*$')]),
    landMark: new FormControl('', [Validators.pattern('^[^*]*$')]),
    district: new FormControl('', [Validators.pattern('^[^*]*$')]),
    state: new FormControl('', [Validators.pattern('^[^*]*$')]),
    note: new FormControl('', [Validators.pattern('^[^*]*$')]),
    familyCode: new FormControl(''),
    pin: new FormControl(''),
    inactive: new FormControl(false,),
  });
  private editIndex$ = new BehaviorSubject<number | null>(null); // Track edit index dynamically
  private pinSubscription: Subscription | null = null;
  private fcSubscription: Subscription | null = null;
  editDetailsForm: FormGroup[] = []
  districtList: any = []
  stateList: any = []
  editContactNo: boolean = false
  addDetails: boolean = false
  showDetails: boolean = false
  isLoading: boolean = false
  userId: any
  reqBody: any = {}
  fcDetails: FamilyCodeResponseObj[] = [];
  ngOnInit(): void {
    this.initializeUserForms()
    this.userId = localStorage.getItem('userId')
    const data = this.data.data.length >= 1 ? this.data?.data.filter((item: { createdBy: any; }) => item.createdBy === parseInt(this.userId)) : []
    this.addDetails = data.length >= 1 ? false : true
    this.editIndex$.subscribe(index => {
      this.subscribeToPinValueChanges(index);
      this.subscribeToFCValueChanges(index);
    });
    this.addDetailsForm.get('familyCode')?.valueChanges.subscribe((value: any) => {
      if (value.length === 12 && this.fcDetails.length === 0) {
        this.checkFamilyCode(value, '')
      }

    })
    this.addDetailsForm.get('pin')?.valueChanges.subscribe((value: any) => {
      if (value.length === 6) {
        this.isLoading = true
        this.onPinChange(value)
      } else {
        this.addDetailsForm.get('state')?.setValue('')
        this.addDetailsForm.get('district')?.setValue('')
      }
    })
    this.editDetailsForm[this.editIndex].get('familyCode')?.valueChanges.subscribe((value: any) => {
      if (value.length === 12 && this.fcDetails.length === 0) {
        this.checkFamilyCode(value, '')
      }

    })

  }
  checkFamilyCode(fc: any, memCode: any) {
    this.isLoading = true;
    this.familyCodeTransmissionService.getFamilyDetails(fc).subscribe({
      next: (response: FamilyCodeResponse) => {
        if (!response.error) {
          this.fcDetails = response.data;
          if (memCode?.length > 0) {
            const name = response.data.find((item: any) =>
              item.mem_key === memCode)
            if (name)
              this.editDetailsForm[this.editIndex].get('familyCode')?.setValue(name.mem_name + ' ' + name.mem_surname)
          }
          this.isLoading = false;

        }
      },
      error: (error: any) => {
        this.isLoading = false;
        this.toaster.error(error);
      },
    });
  }
  onSelectFCDropDown(item: any) {
    this.reqBody = {
      ...this.reqBody, familyCode: item.mem_family_code
      ,
      memberCode: item.mem_key
    }
  }
  onClearClick() {
    if (this.showDetails) {
      this.addDetailsForm.get('familyCode')?.setValue('')

    } else {
      this.editDetailsForm[this.editIndex].get('familyCode')?.setValue('')
      this.editDetailsForm[this.editIndex].get('memberCode')?.setValue('')

    }
    this.fcDetails = []
    const { familycode, memberCode, ...updatedReqBody } = this.reqBody
    this.reqBody = updatedReqBody
  }
  initializeUserForms(): void {
    if (this.data.data.length >= 1) {
      this.editDetailsForm = this.data.data.map((user: any) =>

        this.formBuilder.group({
          note: [user.notes],
          address: [user.address],
          state: [user.state],
          landMark: [user.landmark],
          district: [user.district],
          contactNo: [user.contactNo],
          pin: [user.pincode],
          isEditable: [false],
          createdBy: [user.createdBy],
          inactive: [user.status],
          familyCode: [user.familyCode],
          memberCode: [user.memberCode]
        })

      );
    }
  }
  editIndex: any
  onClickEdit(index: any) {
    this.editIndex = index
    this.initializeUserForms()
    this.editIndex$.next(index);
    this.editDetailsForm.forEach((formGroup, i) => {
      formGroup.get('isEditable')?.setValue(i === index);
      if (formGroup.get('familyCode')?.value > 0)
        this.checkFamilyCode(formGroup.get('familyCode')?.value, formGroup.get('memberCode')?.value)
    });

  }
  onAddClick() {
    this.addDetails = false
    this.showDetails = true
  }
  onEditSaveClick(index: any, action: any) {
    this.isLoading = true
    if (action === 'edit') {
      this.reqBody = {
        ...this.reqBody,
        address: this.editDetailsForm[this.editIndex].get('address')?.value,
        landmark: this.editDetailsForm[this.editIndex].get('landMark')?.value,
        pincode: this.editDetailsForm[this.editIndex].get('pin')?.value,
        district: this.editDetailsForm[this.editIndex].get('district')?.value,
        state: this.editDetailsForm[this.editIndex].get('state')?.value,
        country: 'India',
        contactNo: this.editDetailsForm[this.editIndex].get('contactNo')?.value,
      }

      if (this.data.type === 'pm') {
        this.reqBody.memkey = this.data.memKey.SL_NO
        this.reqBody.notes = this.editDetailsForm[this.editIndex].get('note')?.value
        this.printAndMonitorService.editStagDetails(this.reqBody).subscribe({
          next: res => {
            this.isLoading = false
            this.toaster.success(res.message)
            this.dialogRef.close(true)
          },
          error: (err) => {
            this.isLoading = false
            this.toaster.error(err)
          }
        })
      } else {
        this.defaulterService.editReachDetails(this.data.data[0].id, this.data.data[0].slno || this.data.data[0].memkey
          , this.reqBody).subscribe({
            next: res => {
              this.isLoading = false
              this.toaster.success(res.message)
              this.dialogRef.close(true)
            },
            error: (err) => {
              this.isLoading = false
              this.toaster.error(err)
            }
          })
      }
    } else {
      this.reqBody = {
        ...this.reqBody,
        address: this.addDetailsForm.get('address')?.value,
        landmark: this.addDetailsForm.get('landMark')?.value,
        pincode: this.addDetailsForm.get('pin')?.value,
        district: this.addDetailsForm.get('district')?.value,
        state: this.addDetailsForm.get('state')?.value,
        country: 'India',
        contactNo: this.addDetailsForm.get('contactNo')?.value,
      }
      if (this.data.type === 'pm') {
        this.reqBody.memkey = this.data.memKey.SL_NO
        this.reqBody.notes = this.addDetailsForm.get('note')?.value

        this.printAndMonitorService.addStagDetails(this.reqBody).subscribe({
          next: res => {
            this.isLoading = false
            this.toaster.success(res.message)
            this.dialogRef.close(true)
          },
          error: (err) => {
            this.isLoading = false
            this.toaster.error(err)
          }
        })
      }
      else {
        this.defaulterService.addReachDetails(this.data.data.slno, this.reqBody).subscribe({
          next: res => {
            this.isLoading = false
            this.toaster.success(res.message)
            this.dialogRef.close(true)
          },
          error: (err) => {
            this.isLoading = false
            this.toaster.error(err)
          }
        })
      }
    }
  }
  private subscribeToPinValueChanges(index: number | null): void {
    this.pinSubscription?.unsubscribe();
    if (index !== null && this.editDetailsForm[index]) {
      const pinControl = this.editDetailsForm[index].get('pin');
      if (pinControl) {
        this.pinSubscription = pinControl.valueChanges.subscribe((value: any) => {
          if (value.length === 6) {
            this.isLoading = true
            this.onPinChange(value)
          } else {
            this.editDetailsForm[this.editIndex].get('state')?.setValue('')
            this.editDetailsForm[this.editIndex].get('district')?.setValue('')
          }
        });
      }
    }
  }
  private subscribeToFCValueChanges(index: number | null): void {
    this.fcSubscription?.unsubscribe();
    if (index !== null && this.editDetailsForm[index]) {
      const fc = this.editDetailsForm[index].get('familyCode');
      if (fc) {
        this.fcSubscription = fc.valueChanges.subscribe((value: any) => {
          if (value.length === 12 && this.fcDetails?.length === 0) {
            this.checkFamilyCode(value, '')
          }
        });
      }
    }
  }

  ngOnDestroy(): void {
    this.pinSubscription?.unsubscribe();
    this.fcSubscription?.unsubscribe();
  }
  onPinChange(value: any) {
    this.pincodeTransmissionService.getStateDistrict(value).subscribe({
      next: (res: PincodeInterface) => {
        this.stateList = res.data.states
        this.districtList = res.data.districts
        if (this.showDetails)
          this.addDetailsForm.get('state')?.setValue(this.stateList[0])
        else
          this.editDetailsForm[this.editIndex].get('state')?.setValue(this.stateList[0])
        if (this.districtList.length === 1)
          if (this.showDetails)
            this.addDetailsForm.get('district')?.setValue(this.districtList[0])
          else
            this.editDetailsForm[this.editIndex].get('district')?.setValue(this.districtList[0])
        this.isLoading = false
      },
      error: (err) => {
        this.isLoading = false
        this.toaster.error(err)
      }
    })
  }
  onInactiveClick(event: any, type: any) {
    if (event.target.checked) {
      const dialogRef = this.dialog.open(ExpiredDialogComponent, {
        data: { slNo: this.data.data.slno }
      })
      dialogRef.afterClosed().subscribe((value: boolean) => {
        if (value) {
          this.reqBody.status = 'INACTIVE'
          this.addDetailsForm.get('inactive')?.setValue(true)

        } else
          this.addDetailsForm.get('inactive')?.setValue(false)

      })
    } else {
      this.reqBody.status = ''

      this.addDetailsForm.get('inactive')?.setValue(false)
    }
  }
  onStateChange(state: any, index: any) {

  }
  onDistrictChange(value: any) {

  }
}
